<template>
  <div class="lead-listing">
    <vs-row class="mb-8">
      <vs-col vs-w="12">
        <div class="float-right flex">
          <vs-button
            color="warning"
            type="filled"
            class="btn-color"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload "
            class="btn-color ml-4"
            @click.prevent="exportCsv()"
            >{{ $t("labels.export") }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="filter-card mb-6" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.status") }}</label>
          <v-select
            v-model="status"
            :options="filterStatus"
            :reduce="(filterStatus) => filterStatus.value"
            label="label"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col flex mt-5 sm: w-full md:w-1/3">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="!this.search && !this.status"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="!this.search && !this.status"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card :title="$t('labels.leads')" class="lead-listing">
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{ $t("labels.leads") }}</label>
          </div>
        </div>
        <div
          class="vx-col sm: w-1/2 md:w-1/2 pl-0 pr-0 justify-flex-end addbtn-col sm: mb-0 md:mb-6"
        >
          <router-link :to="{ name: 'AddLead' }">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="float-right btn-add sm: mb-6 md:m-0"
              v-if="checkPermission('lead', 'add')"
              >{{ $t("labels.add_lead") }}</vs-button
            >
          </router-link>
        </div>
      </div>
      <vs-table :data="leads" class="permission">
        <template slot="thead">
          <vs-th class="col-md-4">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-4">{{ $t("labels.email") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.status") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.username">{{ tr.name }}</vs-td>

            <vs-td :data="tr.email">{{ tr.email }}</vs-td>
            <vs-td :data="tr.status">{{ tr.status_name }}</vs-td>
            <vs-td width="264">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.view')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-eye"
                  class="mr-2"
                  color="dark"
                  @click="
                    $router.push({ name: 'ViewLead', params: { id: tr.id } })
                  "
                  v-if="checkPermission('lead', 'view')"
                ></vs-button>
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  @click="
                    $router.push({ name: 'EditLead', params: { id: tr.id } })
                  "
                  v-if="checkPermission('lead', 'modify')"
                ></vs-button>

                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                  v-show="
                    tr.status !== 'W' && checkPermission('lead', 'delete')
                  "
                ></vs-button>
                <vs-button
                  @click="statusPopup(tr.id, tr.status)"
                  type="flat"
                  :title="$t('labels.update_status')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-settings"
                  color="warning"
                  v-show="
                    tr.status !== 'W' && checkPermission('lead', 'modify')
                  "
                ></vs-button>
                <vs-button
                  @click="convertLeadPopup(tr)"
                  type="flat"
                  :title="$t('labels.convert_lead')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-user"
                  color="primary"
                  v-show="
                    tr.status !== 'W' && checkPermission('lead', 'modify')
                  "
                ></vs-button>
                <vs-button
                  @click="
                    $router.push({
                      name: 'ViewUser',
                      params: { id: tr.client_id },
                    })
                  "
                  type="flat"
                  :title="$t('labels.view_client')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-user-check"
                  color="primary"
                  v-show="tr.status === 'W'"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
      <!-- UpdateStatus Popup -->
      <vs-popup
        class="holamundo"
        :title="$t('labels.update_status')"
        :active.sync="popupActive"
      >
        <p class="mb-4">{{ $t("strings.update_status") }}</p>
        <ul class="centerx">
          <li>
            <vs-radio v-model="lead_status" vs-value="N">{{
              $t("labels.new")
            }}</vs-radio>
          </li>
          <li>
            <vs-radio v-model="lead_status" vs-value="IP">{{
              $t("labels.in_progress")
            }}</vs-radio>
          </li>
          <li>
            <vs-radio v-model="lead_status" vs-value="A">{{
              $t("labels.approved")
            }}</vs-radio>
          </li>
          <li>
            <vs-radio v-model="lead_status" vs-value="R">{{
              $t("labels.rejected")
            }}</vs-radio>
          </li>
        </ul>
        <vs-button
          class="vs-component vs-button mt-4 vs-button-primary vs-button-filled login-btn"
          :disabled="button_loading"
          @click.prevent="updateStatus()"
          id="update-status"
          >{{ $t("labels.update_status") }}
        </vs-button>
      </vs-popup>

      <!-- Convert Lead to Client Popup -->
      <vs-popup
        class="holamundo"
        :title="$t('labels.convert_lead')"
        :active.sync="popupConvertLead"
        button-close-hidden
      >
        <form
          @submit.prevent="checkValidation()"
          autocomplete="off"
          class="lead-form w-full"
          v-if="lead"
        >
          <div class="flex w-full vx-row m-0">
            <div
              class="vx-col sm: w-full md:w-full lg:w-1/1 d-theme-dark-bg p-0"
            >
              <div class="vx-row w-full mx-0 justify-center mt-2 lead-subtype">
                <div class="vx-col w-full justify-space-between pl-0">
                  <ul class="md:flex subtypes md:justify-around">
                    <li
                      v-for="stype in subtypes"
                      :key="stype.value"
                      class="convert_lead"
                    >
                      <vs-radio v-model="subtype" :vs-value="stype.value">{{
                        stype.label
                      }}</vs-radio>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="vx-row w-full mx-0">
                <div
                  class="vx-col sm: w-full md:w-1/2 type mt-6"
                  v-if="showo === true && !editRoute"
                >
                  <label class="pl-1">{{ $t("labels.owner") }}</label>
                  <v-select
                    v-validate="'required'"
                    v-model="owner"
                    :options="owners"
                    name="owner"
                    :reduce="(subtype) => subtype.id"
                    label="name"
                    @input="getManagers()"
                  />
                  <span class="text-danger text-sm">{{
                    errors.first("owner")
                  }}</span>
                </div>
                <div
                  class="vx-col sm: w-full md:w-1/2 type mt-6"
                  v-if="showm === true && !editRoute"
                >
                  <label class="pl-1">{{ $t("labels.manager") }}</label>
                  <v-select
                    v-validate="'required'"
                    v-model="manager"
                    :options="managers"
                    name="manager"
                    :reduce="(subtype) => subtype.id"
                    label="name"
                    @input="getOffice()"
                  />
                  <span class="text-danger text-sm">{{
                    errors.first("manager")
                  }}</span>
                </div>
                <div
                  class="vx-col sm: w-full md:w-1/2 type mt-6"
                  v-if="showof === true && !editRoute"
                >
                  <label class="pl-1">{{ $t("labels.office") }}</label>
                  <v-select
                    v-validate="'required'"
                    v-model="office"
                    :options="offices"
                    name="office"
                    :reduce="(subtype) => subtype.id"
                    label="name"
                  />
                  <span class="text-danger text-sm">{{
                    errors.first("office")
                  }}</span>
                </div>
              </div>
              <div class="vx-row mt-6 m-0">
                <div class="vx-col sm: w-full p-0 md:px-4">
                  <vs-input
                    v-validate="'required|email'"
                    type="role"
                    class="w-full"
                    name="email"
                    :label="$t('labels.email')"
                    v-model="lead.email"
                    icon-no-border
                    :placeholder="$t('labels.email')"
                  />
                  <span class="text-danger text-sm">{{
                    errors.first("email")
                  }}</span>
                </div>
              </div>
              <div class="vx-row mb-4 mt-6 m-0">
                <div class="vx-col w-full p-0 md:px-4">
                  <vs-input
                    type="text"
                    class="w-full"
                    name="name"
                    :label="$t('labels.name')"
                    :placeholder="$t('labels.name')"
                    v-model="lead.name"
                    v-validate="'required|max:255'"
                  />
                  <span class="text-danger text-sm">{{
                    errors.first("name")
                  }}</span>
                </div>
              </div>
              <div class="vx-row mt-6 m-0">
                <div class="vx-col w-full p-0 md:px-4">
                  <vs-input
                    type="text"
                    class="w-full"
                    name="organisation_name"
                    :label="$t('labels.organisation_name')"
                    :placeholder="$t('labels.organisation_name')"
                    v-model="lead.organisation_name"
                    v-validate="'max:255'"
                  />
                  <span class="text-danger text-sm">{{
                    errors.first("organisation_name")
                  }}</span>
                </div>
              </div>
              <div class="vx-row w-full justify-center">
                <vs-button
                  button="submit"
                  class="vs-component vs-button mt-4 vs-button-primary vs-button-filled login-btn mr-4"
                  :disabled="button_loading"
                  id="convert-lead"
                  >{{ $t("labels.convert") }}</vs-button
                >
                <!-- @click.prevent="convertLead()" -->
                <vs-button
                  class="vs-component vs-button mt-4 vs-button-primary vs-button-filled login-btn"
                  color="warning"
                  @click.prevent="cancelPopupActive()"
                  >{{ $t("labels.cancel") }}</vs-button
                >
              </div>
            </div>
          </div>
        </form>
      </vs-popup>
    </vx-card>
  </div>
</template>

<script>
import { KeyIcon } from "vue-feather-icons";

export default {
  components: {
    KeyIcon,
  },
  data() {
    return {
      totalPage: 1,
      leads: [],
      popupActive: false,
      popupConvertLead: false,
      lead_status: "",
      selectedId: 0,
      subtype: "OW",
      email: "",
      name: "",
      organisation_name: "",
      role: null,
      // role_id: null,
      roles: [],
      subtypes: [
        { label: this.$t("labels.owner"), value: "OW" },
        { label: "Manager", value: "M" },
        { label: "Office", value: "OF" },
        { label: "Fleet", value: "F" },
      ],
      lead: null,
      showo: false,
      showm: false,
      showof: false,
      owner: null,
      manager: null,
      office: null,
      fleet: null,
      owners: [],
      managers: [],
      offices: [],
      fleets: [],
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      // limit: this.$store.state.limit,
      showfilter: false,
      search: null,
      status: null,
      filterStatus: [
        { label: "New", value: "N" },
        { label: "In Progress", value: "IP" },
        { label: "Approved", value: "A" },
        { label: "Rejected", value: "R" },
        { label: "Won", value: "W" },
      ],
    };
  },
  computed: {},
  watch: {
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getLeads();
    },
    currentx(val) {
      this.getLeads();
    },
    type(value) {
      this.$validator.reset();
      if (value !== "CL") {
        this.subtype = null;
      }
    },
    subtype(value) {
      if (value == "M") {
        this.getAllOwner();
        this.showo = true;
        this.showm = false;
        this.showof = false;
      } else if (value == "OF") {
        this.getAllOwner();
        this.showo = true;
        this.showm = true;
        this.showof = false;
      } else if (value == "F") {
        this.getAllOwner();
        this.showo = true;
        this.showm = true;
        this.showof = true;
      } else {
        this.owners = [];
        this.showo = false;
        this.showm = false;
        this.showof = false;
      }
    },
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.setValidationMessage();
    this.getLeads();
    this.getRoles();
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.convertLead();
        }
      });
    },

    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deleteLead,
      });
    },
    async deleteLead() {
      if (this.index < 0) return;
      let url = "leads/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.leads[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getLeads();
      }
    },

    async getLeads(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
        status: this.status,
      };
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse("/leads", input);
      if (exp) {
        this.exportFile(response, "Leads");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          let leads = data.leads;
          this.leads = leads;
        }
      }
    },
    async getRoles() {
      let response = await this.getHTTPPostResponse("/role");
      if (response) {
        let data = response.data;
        let roles = data.roles;
        this.roles = roles;
      }
    },
    exportCsv() {
      this.getLeads(true);
    },
    filter() {
      this.getLeads();
    },
    clearFilter() {
      this.search = null;
      this.status = null;
      this.getLeads();
    },
    // Call API for convert lead to client
    convertLeadPopup(lead) {
      this.lead = {
        id: lead.id,
        name: lead.name,
        email: lead.email,
        organisation_name: lead.organisation_name,
        sub_type: lead.subtype,
      };

      this.popupConvertLead = true;
    },
    async convertLead() {
      let input = {
        sub_type: this.subtype,
        email: this.lead.email,
        name: this.lead.name,
        organisation_name: this.lead.organisation_name,
      };

      if (this.subtype == "M") {
        input.parent_id = this.owner;
      } else if (this.subtype == "OF") {
        input.parent_id = this.manager;
      } else if (this.subtype == "F") {
        input.parent_id = this.office;
      }

      let response = await this.getHTTPPostResponse(
        "/leads/convert-to-client/" + this.lead.id,
        input,
        "#convert-lead"
      );
      if (response) {
        let data = response.data;
        this.popupConvertLead = false;
        this.subtype = null;
        this.lead.email = null;
        this.lead.name = null;
        this.lead.organisation_name = null;
        this.getLeads();
        this.$store.commit("resetState", null, { module: "userData" });
      }
    },

    // Call API for Update Status
    async statusPopup(id, status) {
      this.lead_status = status;
      this.selectedId = id;
      this.popupActive = true;
    },
    async updateStatus() {
      let ids = [];
      ids.push(this.selectedId);
      let input = {
        ids: ids,
        status: this.lead_status,
      };
      let response = await this.getHTTPPostResponse(
        "/leads/change-status",
        input,
        "#update-status"
      );
      if (response) {
        let data = response.data;
        this.popupActive = false;
        this.lead_status = "";
        this.selectedId = 0;
        this.getLeads();
      }
    },
    async getAllOwner() {
      var input = {
        type: "CL",
        sub_type: "OW",
      };
      let response = await this.getHTTPPostResponse("/users", input);
      if (response) {
        let data = response.data.users;
        this.owners = data;
      }
    },
    async getManagers() {
      let response = await this.getHTTPGetResponse("/users/get/" + this.owner);
      if (response) {
        let user = response.data.user;
        this.managers = user.children;
      }
    },
    async getOffice() {
      let response = await this.getHTTPGetResponse(
        "/users/get/" + this.manager
      );
      if (response) {
        let user = response.data.user;
        this.offices = user.children;
      }
    },
    // Cancel Button Functionality
    cancelPopupActive() {
      this.isclassActive = false;
      this.inputdisable = false;
      this.subtype = { label: this.$t("labels.owner"), value: "OW" };
      this.email = "";
      this.name = "";
      this.organisation_name = "";
      this.role = null;

      this.subtypes = [
        { label: this.$t("labels.owner"), value: "OW" },
        { label: "Manager", value: "M" },
        { label: "Office", value: "OF" },
        { label: "Fleet", value: "F" },
      ];
      this.popupConvertLead = false;
      this.$validator.reset();
    },
  },
};
</script>
<style scoped>
p {
  font-weight: 600;
}
</style>
